import { Injectable, inject } from '@angular/core';
import { ApiService } from 'src/app/api/api.service';
import { SearchDTO } from '../models/analys-resultat';

@Injectable({
  providedIn: 'root',
})
export class AnalysresultatService {
  private urls = {
    search: 'langtidslager/search',
    calc: 'langtidslager/calc',
    searchGroupByProvId: 'langtidslager/searchGroupByProvId',
    searchGeneral: 'langtidslager/searchGeneral',
    searchGeneralAndGroupByProvId: 'langtidslager/searchGeneralAndGroupByProvId',
    antibiotics: 'langtidslager/antibiotic',
    searchCsv: 'langtidslager/searchCsv',
    searchGeneralCsv: 'langtidslager/searchGeneralCsv',
    namnarDataCsv: 'langtidslager/namnarDataCsv',
    calculateResistanceCsv: 'langtidslager/calculateResistanceCsv',
    countSearch: 'langtidslager/countSearch',
    countKML: 'langtidslager/countKML',
  };
  private apiService = inject(ApiService);

  public searchLTL<T>(searchDTO: SearchDTO) {
    return this.apiService.postAsObservable<T>(this.urls.search, searchDTO);
  }

  public searchGeneral<T>(searchDTO: SearchDTO) {
    return this.apiService.postAsObservable<T>(this.urls.searchGeneral, searchDTO);
  }

  public calculateResistance<T>(searchDTO: SearchDTO) {
    return this.apiService.postAsObservable<T>(this.urls.calc, searchDTO);
  }

  public searchGroupByProvId<T>(searchDTO: SearchDTO,) {
    return this.apiService.postAsObservable<T>(`${this.urls.searchGroupByProvId}?limit=200&offset=${searchDTO.offset}`, searchDTO);
  }

  public searchGeneralAndGroupByProvId<T>(searchDTO: SearchDTO) {
    return this.apiService.postAsObservable<T>(`${this.urls.searchGeneralAndGroupByProvId}?limit=200&offset=${searchDTO.offset}`, searchDTO);
  }

  public getAntibiotics<T>(fyndId: string) {
    return this.apiService.getAsObservable<T>(`${this.urls.antibiotics}/${fyndId}`);
  }

  public getSpecificRowDataCsv<T>(searchDTO: SearchDTO) {
    return this.apiService.postAsObservable<T>(this.urls.searchCsv, searchDTO, 'blob');
  }

  public getNamnarDataCsv<T>(searchDTO: SearchDTO) {
    return this.apiService.postAsObservable<T>(this.urls.namnarDataCsv, searchDTO, 'blob');
  }

  public getGeneralRowDataCsv<T>(searchDTO: SearchDTO) {
    return this.apiService.postAsObservable<T>(this.urls.searchGeneralCsv, searchDTO, 'blob');
  }

  public getCalcCsv<T>(searchDTO: SearchDTO) {
    return this.apiService.postAsObservable<T>(this.urls.calculateResistanceCsv, searchDTO, 'blob');
  }

  public countSearch<T>(searchDTO: SearchDTO) {
    return this.apiService.postAsObservable<T>(this.urls.countSearch, searchDTO)
  }

  public countKML<T>(searchDTO: SearchDTO) {
    return this.apiService.postAsObservable<T>(this.urls.countKML, searchDTO)
  }
}
